import React from 'react';
import ReactDOM from 'react-dom';

const DrawerMenuToggleButton: React.FC = () => {
  const handleClick = () => {
    // ドロワーのnodeを取得する
    const drawer_menu = document.getElementById('drawer-menu-body');
    const drawer_overlay = document.getElementById('drawer-overlay');
    const drawer_body = document.getElementById('drawer-body');
    if (drawer_menu !== null) {
      if (drawer_menu.getAttribute('class') === 'visible') {
        // 隠す
        drawer_menu.removeAttribute('class');
        drawer_menu.setAttribute('class', 'hidden');
      } else {
        // 表示する
        drawer_menu.removeAttribute('class');
        drawer_menu.setAttribute('class', 'visible');
        // overlayの高さを調節する
        if (drawer_overlay !== null) {
          drawer_overlay.style.height = `${
            document.getElementsByTagName('body')[0].clientHeight
          }px`;
        }
        // bodyの高さを調節する
        if (drawer_body !== null) {
          drawer_body.style.height = `${document.getElementsByTagName('body')[0].clientHeight}px`;
        }
      }
    }
  };
  return (
    <div id="toggle-drawer-menu" onClick={handleClick}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

if (document.getElementById('drawer-menu-toggle-button')) {
  ReactDOM.render(<DrawerMenuToggleButton />, document.getElementById('drawer-menu-toggle-button'));
}

export default DrawerMenuToggleButton;
